<template>
  <b-card class="bg-white rounded-xl px-4">
    <!-- <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">List of Blogs</h2>

        <small class="text-muted">Manage all your blogs here. </small>
      </div>

      <base-button
        outline
        class="px-6 py-1 mx-1"
        type="primary"
        @click="handleAdd"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon>Create
          Content</span
        >
      </base-button>
    </div> -->
    <!-- <b-input-group class="mt-4">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        placeholder="Enter Search...."
        v-model="search"
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
        >
          <feather-icon
            class="cursor-pointer mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group> -->
    <BlogsTable />
  </b-card>
</template>

<script>
import BlogsTable from "./components/BlogsTable.vue";
import { mapState } from "vuex";

export default {
  components: {
    BlogsTable,
  },
  computed: {
    ...mapState("cms", {
      pageCategories: "pageCategories",
      filtertags: "filtertags",
      filters: "filters",
      pages: "pages",
      categorywisepages: "categorywisepages",
    }),
  },
  methods: {
    handleAdd() {
      this.$router.push({ name: "addblogcontent" });
    },
    async init() {
      let categoryId = "";
      await this.$store.dispatch("cms/getPageCategories");

      this.pageCategories.forEach((element) => {
        if (element.route.includes("blogs")) categoryId = element._id;
      });
      await this.$store.dispatch("cms/getTagsbyCategory", {
        categoryPage: categoryId,
      });
      await this.$store.dispatch("cms/getfilterbycategory", {
        categoryPage: categoryId,
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
